// Modules
import { useRouter } from "next/router";
import { useCallback } from "react";

// Redux
import { setActiveFiltersAndUrlPath } from "redux/searchPage/filters/filtersSlice";
import { useAppDispatch } from "redux/hooks";

// Types
import { ParsedUrlQuery } from "querystring";

// Utils
import { createStringFromQueryObject } from "utils/searchPage/queryString";

const useRouting = () => {
	const router = useRouter();
	const dispatch = useAppDispatch();

	const pushNewRoute = useCallback(
		async (newQueryString: ParsedUrlQuery | string) => {
			if (router.isReady) {
				let pathname = "";
				if (typeof newQueryString === "string") {
					if (newQueryString !== "/") {
						pathname = newQueryString;
					}
				} else {
					pathname = createStringFromQueryObject(newQueryString);
				}

				const result = await dispatch(setActiveFiltersAndUrlPath(pathname));

				if (setActiveFiltersAndUrlPath.fulfilled.match(result)) {
					const updatedPathname = result.payload.pathname;
					await router.push(updatedPathname, undefined, { shallow: true });
				}
			}
		},
		[router]
	);
	return pushNewRoute;
};

export default useRouting;
